module.exports = __webpack_public_path__ + "img/googleplay.ecc4fa85.png";